import React, { createContext, useState } from 'react';
import '../sass/styles.scss';

import { UseParamsProps } from '../utils/useParams';
import { getParams } from '../utils/getParams';
const siteUrl = 'https://payfit.com';

export interface ThemesBrandSystemType {
  siteUrl?: string;
  language?: string;
  allLangages: {
    fr: { label: 'France'; url: `/fr` };
    en: { label: 'United Kingdom'; url: '/' };
    es: { label: 'España'; url: `/es` };
  };
  slug?: string;
  style?: any;
  env?: any;
  imgs?: any;
  shortcodes?: any;
  tracking?: any;
  urlParams?: UseParamsProps;
  setUrlParams?: React.Dispatch<React.SetStateAction<UseParamsProps>>;
}
export const themesBrandSystem: ThemesBrandSystemType = {
  siteUrl,
  language: 'fr',
  allLangages: {
    fr: { label: 'France', url: `/fr` },
    en: { label: 'United Kingdom', url: '/' },
    es: { label: 'España', url: `/es` },
  },
  slug: '',
  style: null,
  env: null,
  imgs: {
    doodle: {
      blue: '/img/doodleblue.svg',
      white: '/img/doodlewhite.svg',
    },
  },
  urlParams: getParams(),
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setUrlParams: () => {},
};

export const BrandSystemContext = createContext(themesBrandSystem);
export const BrandSystemProvider = ({
  value = themesBrandSystem,
  children,
}: any) => {
  const [urlParams, setUrlParams] = useState<UseParamsProps>({});

  return (
    <BrandSystemContext.Provider
      value={{
        ...value,
        urlParams,
        setUrlParams,
      }}
    >
      {children}
    </BrandSystemContext.Provider>
  );
};
